import React, { useContext } from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import { QuestionnaireModalProvider } from './utils/questionnaire_modal_context';
import { VonjoModalProvider } from './utils/vonjo_modal_context';

import MemberPlatformHeader from './components/header/member_platform_header';
import Header from './components/header';
import SimpleHeader from './components/simple_header';
import ProviderHeader from './components/provider_header';
import PreSignupForm from './components/join/pre_signup';
import CosmeticLandingPage from './containers/cosmetic/landing_page';
import SpineSurgeryPatientMentor from './containers/spine_surgery/patient_mentor';
import SpineSurgeryVirtualConsultation from './containers/spine_surgery/virtual_consultation';
import CosmeticVirtualConsultation from './containers/cosmetic/virtual_consultation';
import MentorMatch from './components/member/mentor_match';
import Context from './utils/context';
import Footer from './components/footer';
import Profile from './components/profile';
import Home from './containers/home';
import UterineFibroids from './containers/uterine_fibroids';
import UterineFibroidsMentorMatch from './components/uterine_fibroids/mentor_match';
import UterineFibroidsSurgeonMatch from './components/uterine_fibroids/surgeon_match';
import Xcopri from './containers/xcopri';
import BetterIsPossible from './components/uterine_fibroids/better_is_possible';
import MentorMatchNybg from './containers/mentor_match/nybg';
import MentorMatchCti from './containers/mentor_match/cti';
import MentorMatchReactiv8 from './containers/mentor_match/reactiv8';
import MentorMatchReactiv8Aus from './containers/mentor_match/reactiv8_aus';
import MentorMatchOssio from './containers/mentor_match/ossio';
import MentorMatchDrMoisesJacobs from './containers/mentor_match/medtronic/dr-moises-jacobs';
import MentorMatchDrAmirAryaie from './containers/mentor_match/medtronic/dr-amir-aryaie';
import MentorMatchDrBroderick from './containers/mentor_match/medtronic/dr-broderick';
import MentorMatchDrMutafyan from './containers/mentor_match/medtronic/dr-mutafyan';
import SurgeonVirtualConsultationConfirm from './components/surgeon_virtual_consultation_confirm';
import RealselfTummyTuck from './containers/realself/tummy_tuck';
import RealselfLiposuction from './containers/realself/liposuction';
import RealselfHeader from './components/realself_header';
import PostConversationQuestionnaire from './components/conversations/post_conversation_questionnaire';
import WomensHealthPreConversationQuestionnaire from './components/questionnaire/womens_health/pre_conversation';
import BetaDoctorConnectQuestionnaire from './components/questionnaire/beta_doctor_connect';
import DoctorConnectAcl from './components/beta_doctor_connect/acl';
import JoinDoctorConnect from './components/beta_doctor_connect/join';
import DoctorConnectAgnostic from './components/beta_doctor_connect/agnostic';
import SurgeonMatchShow from './components/surgeon_matches/show';
import DirectSurgeonMatchShow from './components/direct_surgeon_matches/show';
import VonjoQuestionnaire from './components/questionnaire/vonjo';
import Reactiv8Questionnaire from './components/questionnaire/reactiv8';
import OssioQuestionnaire from './components/questionnaire/ossio';
import MedtronicQuestionnaire from './components/questionnaire/medtronic';
import HerniaQuestionnaire from './components/questionnaire/hernia';
import XcopriQuestionnaire from './components/questionnaire/xcopri';
import QuestionnaireModal from './components/ui_kit/modals/questionnaire_modal';
import VonjoModal from './components/ui_kit/modals/vonjo_modal';

let path = window.location.pathname;
export const renderHeader = (auth) => {
  const currentUser = auth.getCurrentUser();

  if (!auth.isLoggedIn()) {
    if (path === '/member/join') {
      return <SimpleHeader logoClickable />;
    }

    if (path.includes(`post-survey`) && useContext(Context).viewport.getIsMobile()) {
      return <SimpleHeader />;
    }

    if (path.includes('procedures') && path.includes('uterine-fibroids')) {
      return <SimpleHeader />;
    }

    if (path.includes('treatments/skx')) {
      return (
        <SimpleHeader
          returnTo={path}
          logo='https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/xcopriheader.jpg'
        />
      );
    }

    if (path.includes('treatments/spv')) {
      return (
        <SimpleHeader
          logo='https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/vonjologo.png'
          showLogin={false}
          isSticky={false}
        />
      );
    }

    if (path.includes('treatments/ossio')) {
      return (
        <SimpleHeader
          returnTo={path}
          logo='https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/ossio-log.png'
        />
      );
    }

    if (path.includes('mentor-match/reactiv8')) {
      return (
        <SimpleHeader
          returnTo={path}
          logo='https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/reactiv8/reactiv8-logo.png'
        />
      );
    }

    if (path.includes('treatments/gastricsleevecenter')) {
      return <SimpleHeader returnTo={path} logo='' />;
    }

    if (path.includes('treatments/bmisurgical')) {
      return (
        <SimpleHeader
          returnTo={path}
          logo='https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/logos/png/BMIq-e1704493537494.png'
        />
      );
    }

    if (path.includes('treatments/drmutafyan')) {
      return (
        <SimpleHeader
          returnTo={path}
          logo='https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/logos/png/mutafyan.png'
        />
      );
    }

    if (path.includes('treatments/broderick')) {
      return (
        <SimpleHeader
          returnTo={path}
          logo='https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/logos/png/uc-san-diego-health4.png'
        />
      );
    }

    if (path.includes('treatments/')) {
      return <SimpleHeader returnTo={path} />;
    }

    return <Header />;
  }

  if (path.includes('mentor-match') && path.includes('surgeon')) {
    return <SimpleHeader />;
  }

  if (path === '/member/join') {
    return <SimpleHeader />;
  }

  if (currentUser.current_profile_type === 'SurgeonAdministrativeAssistant') {
    return <ProviderHeader />;
  }

  if (
    currentUser &&
    currentUser.current_profile_type === 'Patient' &&
    currentUser.current_profile &&
    currentUser.current_profile.surgeries_or_treatments.includes('VONJO')
  ) {
    return <MemberPlatformHeader hideLinks={true} />;
  }

  if (
    currentUser.current_profile_type === 'Patient' ||
    currentUser.current_profile_type === 'PatientPartner' ||
    currentUser.current_profile_type === 'SuperUser'
  ) {
    return <MemberPlatformHeader hideLinks={window.location.pathname.startsWith(`/member/join/`)} />;
  }

  return <></>;
};

const AuthenticatedRoute = ({ component: Component, path, auth }) => {
  const returnTo = window.location.pathname;
  const pathname = `/member/login?return_to=${encodeURIComponent(returnTo)}`;

  if (auth.isLoggedIn()) {
    return <Route path={path} render={(props) => <Component {...props} />} />;
  }

  return <Route path={path} render={(props) => <Redirect to={pathname} />} />;
};

const PublicOnlyRoute = ({ component: Component, auth, path }) => {
  let redirectUrl = '/member/conversations';
  if (auth.isLoggedIn() && auth.getCurrentUser().current_profile_type === 'SurgeonAdministrativeAssistant') {
    redirectUrl = '/provider/insights';
  }
  if (auth.isLoggedIn() && auth.getCurrentUser().is_nybg) {
    redirectUrl = '/provider/mentor-connect';
  }

  return (
    <Route
      exact
      path={path}
      render={(props) =>
        auth.isLoggedIn() ? <Redirect to={{ pathname: redirectUrl }} /> : <Component path={path} {...props} />
      }
    />
  );
};

export const NewApp = () => {
  const context = useContext(Context);

  let footerBgColor = '#173959';
  let footerColumnHeaderStyles = null;
  if (path && path === '/treatments/skx') {
    footerBgColor = '#4E2B6F';
    footerColumnHeaderStyles = { color: '#FFF' };
  }
  if (path && path === '/treatments/ossio') {
    footerBgColor = '#63BC47';
    footerColumnHeaderStyles = { color: '#FFF' };
  }
  if (path && path === '/treatments/spv') {
    footerBgColor = '#EC9202';
    footerColumnHeaderStyles = { color: '#FFF' };
  }
  if (path && path === '/mentor-match/reactiv8') {
    footerBgColor = '#129A76';
    footerColumnHeaderStyles = { color: '#FFF' };
  }

  return (
    <>
      {renderHeader(context.auth)}

      <QuestionnaireModalProvider>
        <QuestionnaireModal />
        <VonjoModalProvider>
          <VonjoModal />
          <Switch>
            <PublicOnlyRoute exact auth={context.auth} path='/' component={Home} />
            {/* Need to deprecate these routes */}
            <Route exact path={`/doctor-connect/acl-reconstruction`} component={Home} />
            <Route exact path={`/doctor-connect`} component={Home} />
            <Route path={`/doctor-connect/acl-reconstruction/:id`} component={Home} />
            <Route path={`/doctor-connect/:id`} component={Home} />
            <Route path={`/surgeon-matches/:id`} component={Home} />
            <Route path={`/direct-surgeon-matches/:id`} component={Home} />
            <PublicOnlyRoute exact auth={context.auth} path={`/realself/tummy-tuck/mentor-match`} component={Home} />
            <PublicOnlyRoute exact auth={context.auth} path={`/realself/liposuction/mentor-match`} component={Home} />
            <Route path={`/procedures/cosmetic/virtual-consultation`} component={Home} />
            <Route path={`/procedures/cosmetic`} component={Home} />
            <Route path={`/mentor-match/morehouse`} component={Home} />
            <Route path={`/procedures/spine/virtual-consultation`} component={Home} />
            <Route path={`/surgeon-virtual-consultation-time/:cid/:uid?/confirm`} component={Home} />
            <Route path={`/procedures/spine`} component={Home} />
            <AuthenticatedRoute
              auth={context.auth}
              path={`/procedures/uterine-fibroids/mentor-match`}
              component={Home}
            />
            <AuthenticatedRoute
              auth={context.auth}
              path={`/procedures/uterine-fibroids/surgeon-match`}
              component={Home}
            />
            <Route path={`/procedures/uterine-fibroids`} component={Home} />
            <Route path={`/better-is-possible`} component={Home} />
            <Route path={`/mentor-match/nybg`} component={Home} />
            {/* End need to deprecate these routes */}

            {/* Landing pages */}
            <Route path={`/treatments/skx`} component={Xcopri} />
            <Route path={`/treatments/ossio`} component={MentorMatchOssio} />
            <Route path={`/treatments/spv`} component={MentorMatchCti} />
            <Route path={`/treatments/gastricsleevecenter`} component={MentorMatchDrMoisesJacobs} />
            <Route path={`/treatments/broderick`} component={MentorMatchDrBroderick} />
            <Route path={`/treatments/drmutafyan`} component={MentorMatchDrMutafyan} />
            <Route path={`/treatments/bmisurgical`} component={MentorMatchDrAmirAryaie} />
            <Route path={`/mentor-match/reactiv8`} component={MentorMatchReactiv8} />
            <Route path={`/mentor-match/reactiv8-aus`} component={MentorMatchReactiv8Aus} />
            {/* End Landing pages */}

            {/* Questionnaires  */}
            <AuthenticatedRoute
              auth={context.auth}
              path={`/member/mentor-matches/:id/spv`}
              component={VonjoQuestionnaire}
            />
            <AuthenticatedRoute
              auth={context.auth}
              path={[`/member/mentor-matches/:id/reactiv8`, `/member/mentor-matches/:id/reactiv8-australia`]}
              component={Reactiv8Questionnaire}
            />
            <AuthenticatedRoute
              auth={context.auth}
              path={`/member/mentor-matches/:id/ossio`}
              component={OssioQuestionnaire}
            />
            <AuthenticatedRoute
              auth={context.auth}
              path={`/member/mentor-matches/:id/dr-moises-jacobs`}
              component={MedtronicQuestionnaire}
            />
            <AuthenticatedRoute
              auth={context.auth}
              path={`/member/mentor-matches/:id/dr-amir-aryaie`}
              component={MedtronicQuestionnaire}
            />
            <AuthenticatedRoute
              auth={context.auth}
              path={`/member/mentor-matches/:id/dr-broderick`}
              component={HerniaQuestionnaire}
            />
            <AuthenticatedRoute
              auth={context.auth}
              path={`/member/mentor-matches/:id/xcopri`}
              component={XcopriQuestionnaire}
            />
            {/* End Questionnaires  */}

            {/* Signup form */}
            <PublicOnlyRoute exact auth={context.auth} path={`/member/join/pre-signup`} component={PreSignupForm} />
            {/* End signup form */}

            {/* Redirects */}
            <Route path={`/member/join/support`} render={() => <Redirect to='/member/join/pre-signup' />} />
            <Route path={`/member/join/b/doctor-connect`} render={() => <Redirect to='/member/join/pre-signup' />} />
            <Route path='/member/join/surgeon-match' render={() => <Redirect to='/member/join/pre-signup' />} />
            <Route path={`/member/mentor-match`} render={() => <Redirect to='/member/join/pre-signup' />} />
            <PublicOnlyRoute
              exact
              auth={context.auth}
              path={`/member/join`}
              render={() => <Redirect to='/member/join/pre-signup' />}
            />
            <AuthenticatedRoute
              auth={context.auth}
              path={`/member/join/support/uterine-fibroids`}
              render={() => <Redirect to='/member/join/pre-signup' />}
            />
            <Route
              path={`/member/join/surgeon-match/uterine-fibroids`}
              render={() => <Redirect to='/member/join/pre-signup' />}
            />
            {/* End redirects */}

            {/* Profile */}
            <Route path={`/member/profile/:id`} component={Profile} />
            <Route path={`/member/profile/:id/:view(about-me|health-profile)`} component={Profile} />
            {/* End profile */}

            {/* Conversation survey */}
            <Route
              path={`/member/conversation-survey/:conversationSurveyId`}
              component={PostConversationQuestionnaire}
            />
            {/* End conversation survey */}
          </Switch>
        </VonjoModalProvider>
      </QuestionnaireModalProvider>

      <Footer
        columnHeaderStyles={footerColumnHeaderStyles}
        bgColor={footerBgColor}
        fullFooter={
          path &&
          !path.startsWith('/member') &&
          !path.startsWith('/treatments/ossio') &&
          !path.startsWith('/treatments/spv') &&
          !path.startsWith('/mentor-match/reactiv8') &&
          !path.startsWith('/treatments/broderick') &&
          !path.startsWith('/treatments/gastricsleevecenter') &&
          !path.startsWith('/treatments/bmisurgical') &&
          !context.auth.isLoggedIn()
        }
      />
    </>
  );
};
